import styled from "styled-components";
import { Modal } from "antd";

export const AuthGuardWrapper = styled.div`
  display: inline-block;
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    background-color: #282828;
    border-radius: 18px;
    padding: 0;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-close, .ant-modal-close-x {
    color: #e4e4e7 !important;
    transition: color 0.2s;
    &:hover {
      color: #fff !important;
    }
  }
`;

export const AuthCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #232323;
  border-radius: 18px;
`;

export const BannerImg = styled.img`
  width: 100%;
  height: 110px;
  object-fit: cover;
  border-radius: 18px 18px 0 0;
`;

export const Headline = styled.div`
  font-size: 1rem;
  color: #fff;
  font-weight: 500;
  text-align: center;
  margin-top: 16px;
`;

export const LoginButton = styled.button`
  background: linear-gradient(45deg, #ff6b6b, #ff8e53);
  color: #fff;
  border: none;
  padding: 0.8rem;
  border-radius: 24px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  position: relative;
  overflow: hidden;
  width: 100%;
  justify-content: center;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: 0.5s;
  }

  &:hover {
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4),
      0 0 20px rgba(255, 142, 83, 0.3);
    background: linear-gradient(45deg, #ff8e53, #ff6b6b);

    &:before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(255, 107, 107, 0.3);
  }
`;

export const SignupButton = styled.button`
  background: transparent;
  color: #ff8e53;
  border: 1px solid #ff8e53;
  padding: 0.8rem;
  border-radius: 24px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  justify-content: center;
`;

export const Divider = styled.div`
  width: 100%;
  text-align: center;
  color: #888;
  font-size: 0.95rem;
  margin: 10px 0 16px 0;
  position: relative;
  &:before,
  &:after {
    content: "";
    display: inline-block;
    width: 32%;
    height: 1px;
    background: #444;
    vertical-align: middle;
    margin: 0 8px;
  }
`;

export const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 18px;
`;

export const SocialButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #232323;
  border: 1px solid #444;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  &:hover {
    background: #333;
    border: 1.5px solid #7cff00;
  }
`;

export const StayLoggedOut = styled.div`
  color: #888;
  font-size: 0.95rem;
  text-align: center;
  margin-top: 2px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
`;
